import React, { useEffect, useState } from "react";

import { Container } from "./styled/shop";

import ShopSearch from "./component/shopSearch";
import ShopLocator from "./component/shopLocator";
import EChanggoCard from "./component/eChanggoCard";
import GroupLocator from "./component/groupLocator";
import axios from "axios";

const Shop = () => {
  const [group, setGroup] = useState([]);
  const [cmpnyIntroduce, setCmpnyIntroduce] = useState([]);
  const [store, setStore] = useState([]);

  useEffect(() => {
    getGroup();
    getCmpnyIntroduce();
    getStore();
  }, []);

  // 모임 조회
  const getGroup = async () => {
    const total = 261;
    const totalPages = Math.ceil(total / 20);

    const url = "/api/groupList";
    const req = {
      delYn: "N",
      displayYn: "Y",
      approvalUseYn: "N",
      offset: Math.floor(Math.random() * 14),
      pageNumber: Math.floor(Math.random() * totalPages),
      pageSize: 20,
      paged: true,
    };
    try {
      const res = await axios.post(url, req);
      if (res.status === 200) {
        setGroup(res.data.content);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 회원사 조회
  const getCmpnyIntroduce = async () => {
    const url = "/api/cmpnyIntroduce";
    const req = {
      offset: 0,
      pageNumber: 0,
      pageSize: 20,
      paged: true,
    };
    try {
      const res = await axios.post(url, req);
      if (res.status === 200) {
        setCmpnyIntroduce(res.data.content);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 상생매장 조회
  const getStore = async () => {
    const url = "/api/cmpnyIntroduce";
    const req = {
      offset: 0,
      pageNumber: 0,
      pageSize: 50,
      paged: false,
      gbn: "ss",
    };
    try {
      const res = await axios.post(url, req);
      if (res.status === 200) {
        console.log(res);
        setStore(res.data.content);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container>
      <ShopSearch store={store} cmpnyIntroduce={cmpnyIntroduce} />
      <ShopLocator store={store} cmpnyIntroduce={cmpnyIntroduce} />
      <EChanggoCard />
      <GroupLocator group={group} />
    </Container>
  );
};

export default Shop;
